import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { IWorkspaceStore } from './types';

const DEFAULT_CONTEXT_MENU_ID = '';

export const useWorkspaceStore = create<IWorkspaceStore>()(
  devtools((set) => ({
    contextMenuId: DEFAULT_CONTEXT_MENU_ID,

    setContextMenuId: (id) => set({ contextMenuId: id }),
  }))
)